import { motion } from 'framer-motion';

import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import styles from './Photo.module.css';

import hum from '../../assets/images/hum.webp';
import { BgVideo } from '../BgVideo/BgVideo';

export const Photo = ({ message, authorFontSize, delayStartBgVideo }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  const srcAvatar =
    (message?.image !== '1' && message?.image) ||
    iconsSources[message?.channel];

  return (
    <div className={styles.photo} key={message.id}>
      <div className={styles.avatarAndName}>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className={styles.avatar}
        >
          <div
            className={styles.avatarBg}
            style={{
              background: `url(${
                iconsSources[message?.channel]
              }) center/cover no-repeat `,
            }}
          />
          <img src={srcAvatar} alt="" onError={errorHandler} />
        </motion.div>

        <motion.div
          initial={{
            maskPosition: '100% 100%',
            WebkitMaskPosition: '100% 100%',
          }}
          animate={{ maskPosition: '0% 100%', WebkitMaskPosition: '0% 100%' }}
          transition={{ duration: 0.4, delay: 0.5 }}
          style={{ fontSize: `${authorFontSize}rem` }}
          className={styles.name}
        >
          {message?.author || hideNumber(message?.senderNumber)}
        </motion.div>
      </div>

      <motion.div
        style={{ width: '100%', height: '100%', position: 'relative' }}
        initial={{ scale: 0, originX: 'left', originY: 'top' }}
        animate={{ scale: 1 }}
        transition={{
          duration: 0.7,
          delay: 0.8,
          ease: 'easeOut',
        }}
      >
        <motion.div
          initial={{
            maskPosition: '100% 100%',
            WebkitMaskPosition: '100% 100%',
          }}
          animate={{
            maskPosition: '100% -100%',
            WebkitMaskPosition: '100% -100%',
          }}
          transition={{ duration: 2, delay: delayStartBgVideo + 1 }}
          className={styles.attachBlock}
        >
          <img
            src={message?.attachments[0].url}
            alt={''}
            className={styles.attach}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2, delay: delayStartBgVideo }}
        >
          <img
            src={message?.attachments[1]?.url}
            alt={''}
            className={styles.attachAi}
          />
        </motion.div>

        <BgVideo delay={delayStartBgVideo * 1000} />
      </motion.div>
    </div>
  );
};
